import { render, staticRenderFns } from "./iconContact.vue?vue&type=template&id=125dfd76"
import script from "./iconContact.vue?vue&type=script&lang=js"
export * from "./iconContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports